import { HttpEvent, HttpInterceptorFn, HttpHandlerFn, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionService } from '../../shared/services/session.service';
import { SweetAlertService } from '../services/sweet-alert.service';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const sessionService = inject(SessionService);
  const swal = inject(SweetAlertService);
  const token = sessionService.getToken();
  const authReq = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${token}`)
  });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        if(sessionService.isAuth()){
          swal.warning('Tu sesión ha expirado');
        }
        sessionService.logOut();
      }
      if (error.status === 403) {
        swal.warning('No tienes los permisos necesarios para realizar esta acción');
      }
      return throwError(() => 'session error');
    })
  );
};